
import React from 'react';
import {DashboardTable} from "../dashboard-table";
import { sprintf } from "sprintf-js";
import {dollarToString} from "../../../lib/currency-utils";
import {ADMIN_STYLE_LUT} from "./common";
import { dump_timestamp } from "./common";
import {ErrorDialog, VerifyCancel, VerifyFill, VerifyPendingFundsDialog} from "./dialogs";

const COLUMN_HEADERS = (do_lastname_firm) => {
  return  [
    "Ticket", "Timestamp/Email",
    do_lastname_firm ? "Firm/Last Name" : "Account/Name",
    "Amt/Phone #", "CUSIP", "Coupon",
    "Maturity", "Issuer", "Price", "Settle Date",
  ];
}

const render_actions = (component, item) => {

  const on_change = (ev) => {
    const button = ev.currentTarget.value;
    if (button === "cancel") {
      component.setState({
        reply_text: "",
        cancel_dialog: {
          ticket_id: item.id,
          cusip: item.cusip,
        }
      })
    } else if (button === "cancel_reply") {
      component.setState({
        reply_text: "",
        cancel_dialog: {
          ticket_id: item.id,
          cusip: item.cusip,
          do_reply: true,
        }
      })
    } else if (button === "fill") {
      component.setState({
        reply_text: "",
        fill_px_usd: "",
        fill_dialog: {
          ticket_id: item.id,
        }
      })
    } else if (button === "pending_funds") {
      component.setState({
        pending_funds_dialog: { ticket_id: item.id },
      })
    }

  }
  return (
    <div>
      <select onChange={on_change} value={"action"}>
        <option key={"action"} value={"action"}/>
        <option key={"fill"} value={"fill"}>Fill</option>
        <option key={"cancel"} value={"cancel"}>Cancel</option>
        <option key={"cancel_reply"} value={"cancel_reply"}>Cancel/Reply</option>
        <option key={"pending_funds"} value={"pending_funds"}>Pending Funds</option>
      </select>
    </div>
  )
}

const render_ticket_state = item => {
  const bold_style = {
    fontWeight: "bold",
  }
  return (<div style={bold_style}>
    {item.metadata.state}
  </div>);
}

const generate_table_data = (
  items, component, selected_row, do_actions, closed_time, do_lastname_firm) => {

  const result = [ Array.from(COLUMN_HEADERS(do_lastname_firm)) ];

  if (do_actions) {
    result[0].push("Actions");
  }
  for(let i=0; i < items.length; i++) {
    const item = items[i];
    const cusip = item.metadata.cusip_metadata;
    const line_0 = [];
    line_0.push(item.id);
    line_0.push(dump_timestamp(
      closed_time ? item.closed_timestamp_sec : item.requested));
    line_0.push(do_lastname_firm ? item.metadata.firm_name : item.metadata.account_number);
    line_0.push(dollarToString(item.metadata.amt_usd));
    line_0.push(item.metadata.cusip);
    line_0.push(sprintf("%.2f", cusip.Coupon));
    line_0.push(cusip.Maturity);
    line_0.push(cusip.Issue || cusip.Issuer);
    line_0.push(cusip.Price);
    line_0.push(cusip['Settle Date']);
    if (do_actions) {
      line_0.push(render_actions(component, item))
    }
    result.push(line_0);

    // 2nd row
    const line_1 = [
      render_ticket_state(item),
      item.metadata.email,
      do_lastname_firm ? item.metadata.last_name : item.metadata.name,
      item.metadata.phone,
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    if (do_actions) {
      line_1.push("");
    }
    result.push(line_1);

  }
  return result;
}

const PurchaseTable = props => {

  const component = props.component;
  const closed_time = props.closed_time;
  const selected_row = props.selected_row;
  const data = generate_table_data(
    props.items, component, selected_row, props.actions, closed_time, props.do_lastname_firm);
  if (props.items.length === 0) {
    return null;
  }

  const container_style = {
    overflowX: "auto",
  }

  const style_style = {
    width: "100%",
    tableLayout: "auto",
  }
  let dialog = null;
  if (component.state.cancel_dialog) {
    dialog = (
      <VerifyCancel
        component={component}
        cusip={component.state.cancel_dialog.cusip}
        ticket_id={component.state.cancel_dialog.ticket_id}
        do_reply={component.state.cancel_dialog.do_reply}/>);
  } else if (component.state.fill_dialog) {
    dialog = (
      <VerifyFill
        component={component}
        ticket_id={component.state.fill_dialog.ticket_id}
        />);
  } else if (component.state.error_dialog) {
    dialog = (<ErrorDialog component={component}/>);
  } else if (component.state.pending_funds_dialog) {
    dialog = (<VerifyPendingFundsDialog component={component}/>);
  }
  return (
    <div style={container_style}>
      <DashboardTable
        tableStyle={style_style}
        tdStyleLut={ADMIN_STYLE_LUT(selected_row)}
        onMouseRowEvent={component.onMouseRowEvent}
        onMouseRowClick={component.onMouseRowClick}
        data={data}
      />
      { dialog }
    </div>
  )
}

export { PurchaseTable };
